import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AccordionGroup from '@cx/ui/AccordionGroup';
import { helpers } from '../../../../core/helpers';

export const MsrpFilterComponent = props => {
  const { min, max } = props.filter;
  const [selectedValue, setSelectedValue] = useState(min);

  const handleChange = event => {
    event.preventDefault();
    setSelectedValue(event.target.value);
  };

  const handleApply = () => {
    setSelectedValue(selectedValue);
    props.handleFilterUpdate('msrp', selectedValue);
  };

  const handleReset = () => {
    setSelectedValue(min);
    props.handleFilterUpdate('msrp', min);
  };

  return (
    <section className="vlp-filter">
      <AccordionGroup.Container htmlId="msrpFilter" independent>
        <AccordionGroup.Item header="MSRP" eventKey="1" htmlId="msrpFilterItem">
          <div className="form-group">
            <label htmlFor="msrp">Less than {helpers.getCurrencyValue(selectedValue, 'USD')}</label>
            <input type="range" className="form-control-range" id="msrp" name="msrp" min={min} max={max} aria-describedby="msrpHelp" value={selectedValue} onChange={handleChange} />
            <small id="msrpHelp" className="form-text text-muted">
              Showing cars cheaper than {helpers.getCurrencyValue(selectedValue, 'USD')}
            </small>
          </div>
          <button type="button" className="btn btn-light" id="btnReset" onClick={handleReset} disabled={selectedValue === ''}>
            Reset
          </button>
          &nbsp;
          <button type="button" className="btn btn-primary" id="btnApply" onClick={handleApply} disabled={selectedValue === ''}>
            Apply
          </button>
        </AccordionGroup.Item>
      </AccordionGroup.Container>
    </section>
  );
};

MsrpFilterComponent.propTypes = {
  filter: PropTypes.object,
  handleFilterUpdate: PropTypes.func
};



// WEBPACK FOOTER //
// ./src/components/vehicles/filters/filter/msrpFilter.component.js